import status from './status';
import management from './management';

const vacation = [
  {
    path: '/vacation/status',
    component: () => import('@/page/vacation/Status.vue'),
    redirect: '/vacation/status/current',
    children: [...status],
    meta: {
      name: '연차 현황',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/vacation/management',
    component: () => import('@/page/vacation/Management.vue'),
    children: [...management],
    meta: {
      name: '연차 관리',
      isActive: false,
      isBread: true,
      isDisable: false,
    },
  },
];

export default vacation;
